import actionCreator from 'helpers/actionCreator'
import { SETUP_PROJECTS, SETUP_APPLICATION, SETUP_MOBILE, NOTIFY_HONEYBADGER,
         START_AUTOSAVE_SAGA, APPLY_CAMERA_DATA, LOGIN_AND_RESTART_APP,
         UPDATE_CURRENT_ENTITY, PROJECT_EXPANDED, LOCK_PROJECT, REMOVE_CATCH_EARLY_FLAG,
         UPDATE_UPDATED_AT,
         RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP,
         REMOVE_MANUFACTURER_SPECIFIC_CAMERAS,
         REMOVE_MANUFACTURER_SPECIFIC, ADD_DATABASE_CONFIG_INSTANCE,
         REVERSE_GEOCODE_LOCATION, SHOW_MOBILE_START, HIDE_MOBILE_START,
         SHOW_MOBILE_ERROR, STORE_OFFLINE, STORE_ACTIVE, SIGN_IN, WAIT_FOR_MAP_IDLE,
         CHECK_OFFLINE_LIMITS } from 'actions/applicationActionTypes'

export const setupApplicationAction = actionCreator(SETUP_APPLICATION, 'project', 'stepThrough')
export const setupMobileAction = actionCreator(SETUP_MOBILE, 'offline', 'active', 'cameraDataFilename')
export const setupProjectsAction = actionCreator(SETUP_PROJECTS, 'offline', 'active', 'offlineProject', 'cameraDataFilename')
export const notifyHoneybadgerAction = actionCreator(NOTIFY_HONEYBADGER, 'err', 'action', 'dbName')
export const startAutosaveSagaAction = actionCreator(START_AUTOSAVE_SAGA)
export const applyCameraModelsAction = actionCreator(APPLY_CAMERA_DATA, 'data', 'filename')
export const loginAndRestartAppAction = actionCreator(LOGIN_AND_RESTART_APP, 'active')
export const updateCurrentEntityAction = actionCreator(UPDATE_CURRENT_ENTITY, 'entity')
export const projectExpandedAction = actionCreator(PROJECT_EXPANDED)
export const lockProjectAction = actionCreator(LOCK_PROJECT)
export const removeCatchEarlyFlagAction = actionCreator(REMOVE_CATCH_EARLY_FLAG)
export const updateUpdatedAtAction = actionCreator(UPDATE_UPDATED_AT, 'updatedAt')
export const resetSpecificManufacturerAndRestartAppAction = actionCreator(RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP)
export const removeManufacturerSpecificCamerasAction = actionCreator(REMOVE_MANUFACTURER_SPECIFIC_CAMERAS)
export const removeManufacturerSpecificAction = actionCreator(REMOVE_MANUFACTURER_SPECIFIC)
export const addDatabaseConfigInstanceAction = actionCreator(ADD_DATABASE_CONFIG_INSTANCE, 'database')
export const reverseGeocodeLocationAction = actionCreator(REVERSE_GEOCODE_LOCATION, 'location')
export const showMobileStartAction = actionCreator(SHOW_MOBILE_START)
export const hideMobileStartAction = actionCreator(HIDE_MOBILE_START)
export const showMobileErrorAction = actionCreator(SHOW_MOBILE_ERROR)
export const storeOfflineAction = actionCreator(STORE_OFFLINE, 'offline')
export const storeActiveAction = actionCreator(STORE_ACTIVE, 'active')
export const signInAction = actionCreator(SIGN_IN, 'active')
export const waitForMapIdleAction = actionCreator(WAIT_FOR_MAP_IDLE, 'map')
export const checkOfflineLimitsAction = actionCreator(CHECK_OFFLINE_LIMITS, 'limitType', 'actionArgs')



// WEBPACK FOOTER //
// ./src/actions/applicationActions.js